import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-full font-sans font-semibold text-lg transition-colors duration-300 shadow-sm';
  const variants = {
    primary: 'bg-terracotta text-offwhite hover:bg-terracotta-dark',
    secondary: 'bg-brown text-offwhite hover:bg-opacity-90'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-331">
      {children}
    </motion.button>;
}